import { useTranslation } from "react-i18next";
import type { HistoricalActor, HistoricalReview } from "../../../api/content/historicalReview";

/** Imported review evidence, visibly apart from the local decisions; it approves nothing here. */
export default function HistoricalDecisions({ history }: { readonly history: HistoricalReview }) {
  const { t } = useTranslation();
  function actorLabel(actor: HistoricalActor): string {
    const contact = actor.email === null ? "" : ` (${actor.email})`;
    const mapping = actor.mapping === null ? "" : ` — ${t(`reviews.decisions.external.${actor.mapping}`)}`;
    return `${actor.displayName}${contact}${mapping}`;
  }
  return (
    <div className="space-y-2 border-t pt-3 text-sm">
      <h4 className="font-semibold">{t("reviews.decisions.external.title")}</h4>
      <p className="app-text-muted">{t("reviews.decisions.external.explanation")}</p>
      <p>{t("reviews.decisions.external.author", { name: actorLabel(history.author) })}</p>
      <ul className="space-y-1">
        {history.decisions.map((decision) => (
          <li key={decision.decisionId}>
            <span className="font-semibold">{t(`reviews.decisions.kinds.${decision.kind}`)}</span>{" "}
            {actorLabel(decision.reviewer)}
            {decision.comment !== "" ? <span>: {decision.comment}</span> : null}
            <span className="app-text-muted block text-xs">
              {t("reviews.decisions.external.head", { head: decision.reviewedHead })}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
